import React, { useState } from "react"
import classes from "./pricing.module.scss"
import styled from "@emotion/styled"
import Button from "@material-ui/core/Button"
import { colors } from "../../../library/constants/styles/colors"
import { withStyles } from "@material-ui/styles"
import { Link } from "react-router-dom"
import * as routes from "../../../library/constants/routes"
import CheckOutlined from "@material-ui/icons/CheckOutlined"
import IconButton from "@material-ui/core/IconButton"
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft"
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight"
import { InputLabel, useMediaQuery } from "@material-ui/core"
import { useSelector } from "react-redux"
import { devices } from "../../../library/constants/styles/responsive"
import { key } from "../../../library/utils/generateKey"
import PlainLink from "../../../components/ui/link"
import Select from "@material-ui/core/Select/Select"
import MenuItem from "@material-ui/core/MenuItem"
import { countries } from "../../../library/constants/states"
import FormControl from "@material-ui/core/FormControl/FormControl"
import PlanCard, { PlanContainer, PlanTitle } from "./PlanCard"

const WhiteButton = withStyles({
  root: {
    color: colors.white,
    borderColor: colors.white,
  },
})(Button)

const freePlan = {
  title: "FREE for anyone simplifying meeting calendaring and schedules",
  features: [
    "Create appointments and meetings without dates and times that calendar themselves.",
    "Uniquely create auto-cohorting multi-meetings that coordinate and calendar themselves repeatedly for many participants.",
    "Outside invitees can use your link to pick a time with you.",
    "Users can use calendar intelligence to coordinate the best time for you and your invitees.",
    "Personal Profile page.",
    "Social posting.",
    "Create social and extra-credit Cred.",
    "Create regular events for fellow users.",
    "Personal profile page, finding friends, joining groups, robust bookmarking, academic standards library, and featured products pages.",
  ],
  comingSoonFeatures: [],
}

const plans = [
  {
    title: "Essentials",
    subtitle: "All Member Types",
    description:
      "For anyone who wants to make Holds – labeled open time which can also have minus-time breaks within it in order to control when the AI will place meetings, and to make Interest Groups.",
    description2: "",
    price: "$2.50",
    yearPrice: "$25",
    featuresBlockTitle: "Additional to Free level",
    features: [
      "Sync your Google or Outlook calendar.",
      "Use Holds to tell the AI and outside requesters when to drop-in appointments and meetings. A Hold has your label on bracketed open time which can also have minus-time breaks within it. Educators might use a label like “Parent Conference Time” from 3-4:00 pm Monday through Friday.",
      "Create interest groups.",
      "Create event groups.",
    ],
    comingSoonFeatures: [],
  },
  {
    title: "Teacher Premium",
    subtitle: "Educator Accounts Only",
    description:
      "For gig teachers creating a one-teacher-school group and inviting learners.",
    description2:
      "Educator accounts require 1-time background check fee of $20. ",
    price: "$35.00",
    yearPrice: "$350",
    featuresBlockTitle: "Additional to Free level",
    features: [
      "Create one-teacher-school group and interest groups.",
      "Sync your Google or Outlook calendar.",
      "Create Holds to bracket and label open time.",
      "Create interest and event groups.",
      "Frame your courses to be self-paced but live-intersecting on-demand by building descriptions per step and attaching auto-cohorting class meetings with any step.",
      "Display courses in the featured products section.",
      "Tracking panels.",
      "Create 'Awarded' Cred from your Group (Grades/Marks, Certificates.)",
      "Create a master calendar for your schedule.",
      "Assign study schedules to members.",
      "Use academic standards for all U.S. States and Canada in Course Frames.",
      "Use bookmarking for planning.",
    ],
    comingSoonFeatures: [
      "Create Plans for each learner",
      "Create reports for learners",
      "Courses sequencing",
      "Courses packaging into marketplace with ecommerce sales",
    ],
  },
  {
    title: "School Premium",
    subtitle: "Educator Accounts Only",
    description: "For schools using complex master schedules.",
    description2:
      "School or district, college or university must be authenticated to invite member learners.",
    price: "$4.50/seat",
    featuresBlockTitle: "Additional to Teacher level",
    features: [
      "Claim or create school and districts groups.",
      "Sync Google or Outlook calendars for all users.",
      "Users create Holds to bracket and label open time.",
      "Create interest groups.",
      "Create event groups.",
      "Associate schools under districts for collective analytics.",
      "Authentication to invite learners.",
      "Frame your courses to be self-paced but live-intersecting on-demand by building descriptions per step and attaching auto-cohorting class meetings.",
      "Option for closed social feeds for members.",
      "Build course steps and attach auto-cohorting class meetings by step.",
      "Add academic standards, attachments, links and quizzes to steps.",
      "Display courses in the featured products section.",
      "Tracking panels.",
      "Create Validated Cred badges from your Group – Social, Extra-Curricular, Grades/Marks, Certificates, Degrees and Diplomas.",
      "Create a master calendar for your schedule.",
      "Assign study schedules to members.",
      "Use academic standards for all U.S. States and Canada in Course Frames.",
      "Use bookmarking for planning.",
      "Instant transfer of courses and associated class meetings to substitutes, tutors and new teachers.",
    ],
    calculation: {
      options: [
        50, 100, 250, 500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000,
        6000, 7000, 8000, 9000, 10000, 12000, 14000, 16000, 18000, 20000, 25000,
        30000, 40000, 50000, 75000, 100000, 150000, 200000, 250000, 300000,
      ],
      priceLabel: "seat monthly",
    },
    comingSoonFeatures: [
      "Create Knowplans for each learner",
      "Create reports for learners",
      "Featured product direct integration into Courses",
      "Invenstory, roll-up of records keeping and product licensing tracking",
      "Single Sign-On for member accounts input",
      "Rostering integrations",
      "Advanced data views school-wide",
      "Custom integrations and security",
    ],
  },
  {
    title: "Company Premium",
    subtitle: "Representative Accounts Only",
    description:
      "For companies wanting to offer automatic demo scheduling to member types.",
    description2:
      "Companies wanting to offer demos to the learner type or under-age must be authenticated.",
    price: "$12.00",
    yearPrice: "$120",
    featuresBlockTitle: "Additional to Free level",
    features: [
      "Create your company group and interest groups.",
      "Authentication for offering demo scheduling to Learners (which may include parents), and educators.",
      "Sync Google or Outlook calendars for all users.",
      "Associate a 'School' premium account under your company premium account to offer courses with live teaching or tutoring.",
      "Use Holds to tell the AI and outside requesters when to drop-in appointments and meetings. A Hold has your label on bracketed open time which can also have minus-time breaks within it. Your company agents might use a label like 'Demo Time' from 9-12:00pm Monday through Friday.",
      "Build product tiles in the featured products section of the site with full descriptions.",
      "Create interest groups.",
      "Create event groups.",
    ],
    comingSoonFeatures: [
      "eCommerce accounts and payments with license tracking",
      "Advertising boosts and blasts",
      "Story posting",
    ],
  },
]

// const mobilePlans = flattenDeep(plans).map((p) => [p])

const PricingPage = () => {
  const { isLoggedIn } = useSelector(({ auth }) => auth)
  const isMobile = useMediaQuery("(max-width:599px)")
  const step = 1
  // const step = isMobile ? 1 : 4
  // const usedPlans = !isMobile ? plans : mobilePlans
  const [page, setPage] = useState(0)

  const [offset, setOffset] = useState(0)

  const [currentPrice, setCurrentPrice] = useState(1.5)
  const [seats, setSeats] = useState(50)

  const navigatePrev = () => {
    if (offset === 0) return
    setOffset((prevState) => prevState - step)
  }

  const navigateNext = () => {
    if (offset >= plans.length) return
    setOffset((prevState) => prevState + step)
  }

  const navigation = isMobile ? (
    <>
      <span className={"mr15 font-16"}>see more</span>
      <IconButton
        aria-label="Previous"
        onClick={navigatePrev}
        disabled={offset === 0}
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        aria-label="Next"
        onClick={navigateNext}
        disabled={offset + step >= plans.length}
      >
        <KeyboardArrowRight />
      </IconButton>
    </>
  ) : (
    <>
      <div>
        {offset !== 0 && (
          <Button
            color={"primary"}
            aria-label="Previous"
            onClick={navigatePrev}
            startIcon={<KeyboardArrowLeft />}
          >
            See previous levels
          </Button>
        )}
      </div>
      <div>
        {offset + 4 < plans.length && (
          <Button
            color={"primary"}
            aria-label="Next"
            onClick={navigateNext}
            endIcon={<KeyboardArrowRight />}
          >
            See next levels
          </Button>
        )}
      </div>
    </>
  )

  return (
    <div className={classes.page}>
      <div>
        <Row bg={colors.grey7}>
          <div className="container">
            <div className="flexgrid full-width">
              <FreePlanContainer>
                <PlanContainer>
                  <PlanTitle>{freePlan.title}</PlanTitle>
                  <FreePlanFeatures>
                    {freePlan.features.map((f) => (
                      <div className={"mb15 f"} key={f}>
                        <CheckOutlined color={"primary"} className={"mr15"} />
                        <span>{f}</span>
                      </div>
                    ))}
                  </FreePlanFeatures>
                </PlanContainer>
              </FreePlanContainer>

              <div className={`full-width f aic jcfe pt15 pb30`}>
                {navigation}
              </div>
              <Container>
                {plans
                  .slice(offset, isMobile ? offset + 1 : offset + 4)
                  .map((p, i) => (
                    <PlanCard plan={p} key={i} />
                  ))}
              </Container>
            </div>
          </div>
        </Row>
      </div>
    </div>
  )
}

const Row = styled.div`
  display: flex;
  align-items: center;
  min-height: 54px;
  padding: ${(props) => props.padding || "15px 0"};
  background-color: ${(props) => props.bg || colors.white};
`
const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
  //margin-bottom: 100px;

  @media ${devices.xs} {
    padding-inline: 15px;
    grid-template-columns: 1fr;
  }
`

const FreePlanContainer = styled.div`
  @media ${devices.xs} {
    padding-inline: 15px;
  }
`

const FreePlanFeatures = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-top: 30px;

  @media ${devices.xs} {
    grid-template-columns: 1fr;
  }
`

export default PricingPage
